import {useEffect, useState} from "react";
import {getItemCategories} from "../api/apiClient";

export const useItemCategories = () => {
    const [itemCategories, setItemCategories] = useState([]);

    useEffect(() => {
        const abortController = new AbortController();

        getItemCategories(abortController.signal)
            .then((data) => {
                setItemCategories(data.itemCategories);
            })
            .catch((error) => console.log(error));

        return () => {
            abortController.abort();
        };
    }, []);

    return {itemCategories};
};
